import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { delay, Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApplicationGroup } from '../../enums/application-group.enum';
import { ApplicationForm } from '../../models/application-form';
import { ApplicationFormDetails } from '../../models/application-form-details';
import { ApplicationFormHistory } from '../../models/application-form-history';
import { TableRequestData } from '../../models/table/table-request-param';
import { TableResponse } from '../../models/table-response';
import { HttpUtils } from '../../utils/http.utils';

@Injectable({ providedIn: 'root' })
export class ApplicationFormsApi {
  readonly #httpClient = inject(HttpClient);
  readonly #apiUrl = environment.API_EWNIOSKI + '/admin/application-forms';

  readonly #applicationForms: ApplicationForm[] = [
    {
      id: 1,
      kod: 'DS-R',
      nazwa: 'Dodatek z tytułu rozpoczęcia roku szkolnego',
      grupa: 'Dobry Start',
      usuniety: false,
    },
    {
      id: 2,
      kod: 'FA-1',
      nazwa: 'Wniosek o świadczenia z funduszu alimentacyjnego',
      grupa: 'Fundusz Alimentacyjny',
      usuniety: false,
    },
    {
      id: 3,
      kod: 'KDR',
      nazwa: 'Wniosek o przyznanie Karty Dużej Rodziny',
      grupa: 'Karta Dużej Rodziny',
      usuniety: false,
    },
    {
      id: 4,
      kod: 'SR-2',
      nazwa: 'Wniosek o zasiłek rodzinny oraz dodatki',
      grupa: 'Świadczenia Rodzinne',
      usuniety: true,
    },
    {
      id: 5,
      kod: 'SW-R',
      nazwa: 'Wniosek o świadczenie wychowawcze',
      grupa: 'Świadczenia Wychowawcze',
      usuniety: false,
    },
    {
      id: 6,
      kod: 'SW-Z',
      nazwa: 'Zmiana danych do świadczenia wychowawczego',
      grupa: 'Świadczenia Wychowawcze',
      usuniety: true,
    },
    {
      id: 7,
      kod: 'ZA-KR',
      nazwa: 'Załącznik do wniosku dla koordynacji',
      grupa: 'Świadczenia Rodzinne',
      usuniety: false,
    },
  ];

  readonly #applicationFormsDetails: ApplicationFormDetails[] = [
    {
      id: 1,
      kod: 'SW-R',
      nazwa: 'Przykładowa nazwa',
      grupa: ApplicationGroup.SW,
      kodTech: '12312',
      usuniety: false,
      czyMozliwaKorespondencja: true,
      czyKorespondencjaAktywna: true,
      wyswietlajDlaObszarow: [],
      zmianaObszaru: false,
      miesiacOd: 0,
      miesiacDo: 11,
      dzienOd: 1,
      dzienDo: 20,
    },
    {
      id: 2,
      kod: 'FA-1',
      nazwa: 'Wniosek o świadczenia z funduszu alimentacyjnego',
      grupa: ApplicationGroup.FA,
      kodTech: 'FA1001',
      usuniety: false,
      czyMozliwaKorespondencja: false,
      czyKorespondencjaAktywna: false,
      wyswietlajDlaObszarow: [],
      zmianaObszaru: false,
      miesiacOd: null,
      miesiacDo: null,
      dzienOd: null,
      dzienDo: null,
    },
  ];

  getApplicationForms$(
    tableRequest: TableRequestData,
  ): Observable<TableResponse<ApplicationForm>> {
    const useMock = false;

    if (!useMock) {
      return this.#httpClient.get<TableResponse<ApplicationForm>>(
        `${this.#apiUrl}`,
        {
          params: HttpUtils.toHttpParams(tableRequest),
          withCredentials: true,
        },
      );
    }

    const totalElements = this.#applicationForms.length;
    const content = this.#applicationForms;

    return of({
      content,
      page: {
        size: totalElements,
        number: 0,
        totalElements,
        totalPages: totalElements === 0 ? 0 : 1,
      },
    }).pipe(delay(200));
  }

  getApplicationFormDetails$(id: number): Observable<ApplicationFormDetails> {
    const useMock = false;

    if (useMock) {
      const applicationForm =
        this.#applicationFormsDetails.find((item) => item.id === id) ??
        this.#applicationFormsDetails[0];

      return of(applicationForm).pipe(delay(200));
    }

    return this.#httpClient.get<ApplicationFormDetails>(
      `${this.#apiUrl}/${id}`,
      {
        withCredentials: true,
      },
    );
  }

  getApplicationFormHistoryTable$(
    id: number,
    params: TableRequestData,
  ): Observable<TableResponse<ApplicationFormHistory>> {
    return this.#httpClient.get<TableResponse<ApplicationFormHistory>>(
      `${this.#apiUrl}/${id}/historia`,
      {
        params: HttpUtils.toHttpParams(params),
        withCredentials: true,
      },
    );
  }

  updateApplicationForm$(
    payload: ApplicationFormDetails,
  ): Observable<ApplicationFormDetails> {
    const useMock = false;

    if (useMock) {
      const applicationForm =
        this.#applicationFormsDetails.find((item) => item.id === payload.id) ??
        this.#applicationFormsDetails[0];

      console.log('[ApplicationFormsApi] updateApplicationForm$', {
        payload,
      });

      void payload;

      return of(applicationForm).pipe(delay(200));
    }

    return this.#httpClient.put<ApplicationFormDetails>(
      `${this.#apiUrl}/update`,
      payload,
      {
        withCredentials: true,
      },
    );
  }
}
